import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { Redirect } from 'react-router-dom';
import { TextField } from '@material-ui/core';
import { Helmet } from 'react-helmet';

import MySnackbarContentWrapper from '../../shared/snackbars/MySnackbarContentWrapper';
import ProductCard from './ProductCard';
import { getProducts } from '../../shared/requests/shop/ProductRequests';
import { getUserInfo } from '../../shared/requests/UserInfoRequests';
import { addProductToCart } from '../../shared/requests/shop/CartRequests';
import { userLogoutRequestSynch } from '../../actions/LogoutActions';

import errorIcon from '../../static/img/icons/warning_icon.svg';
// import saleBanner from '../../static/img/saleBanner.png';


const styles = theme => ({
  headerSection: {
    textAlign: 'center',
    margin: theme.spacing(5),
  },
  header: {
    fontSize: '2.125rem',
    marginBottom: theme.spacing(),
  },
  loadingSpinner: {
    margin: theme.spacing(3),
  },
  card: {
    width: 220,
    margin: theme.spacing(2),
  },
  cardMedia: {

  },
  list: {
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'center',
  },
  loggedOutMessage: {
    marginBottom: theme.spacing(),
  },
  cardActions: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
  },
  cardContent: {
    paddingBottom: 0,
  },
  actionArea: {
    margin: 'auto',
    textAlign: 'center',
    padding: ` 0 ${theme.spacing(4)} `,
  },
  action: {
    marginRight: theme.spacing(),
    marginLeft: theme.spacing(),
  },
  errorIcon: {
    height: 80,
    width: 80,
    marginBottom: theme.spacing(3),
  },
  loggedOutContainer: {
    marginTop: theme.spacing(4),
    textAlign: 'center',
  },
  loggedOutOptions: {
    margin: theme.spacing(2),
  },
  saleBanner: {
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing(4),
  },
  saleBannerImg: {
    width: '100%',
    maxWidth: '100%',
  },
});

class ProductList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loggedIn: false,
      hasMembership: false,
      addButtonLoading: false,
      loading: true,
      snackbarOpen: false,
      snackbarVariant: '',
      snackbarMessage: '',
      products: [],
      userInfo: {},
      filter: '',
      filteredProducts: [],
      notFound: false,
    };

    this.handleClose = this.handleClose.bind(this);
    this.addToCart = this.addToCart.bind(this);
  }

  componentDidMount() {
    const { token, id, dispatch } = this.props;
    const { category } = this.props.match.params;
    // category not found?
    if (category !== 'routines' && category !== 'music' && category !== 'trainers' && category !== 'videos') {
      this.setState({ notFound: true });
    } else {
      // check if logged in
      if (token) {
        this.setState({
          loggedIn: true,
        });
      }
      // get products in category
      getProducts(category)
        .then((response) => {
          // console.log(response.data);
          this.setState({
            filteredProducts: response.data,
            products: response.data,
            loading: false,
            filter: '',
          });
        })
        .catch((error) => {
          console.log('failed to get products');
          console.log(error.response);
          this.setState({
            snackbarOpen: true,
            snackbarVariant: 'error',
            snackbarMessage: 'Failed to load products',
          });
        });

      // does user have membership?
      if (token && id) {
        getUserInfo(token, id)
          .then((response) => {
            console.log('got user info');
            console.log(response.data);
            this.setState({
              userInfo: response.data,
            });
            if (response.data.has_membership) {
              this.setState({
                hasMembership: true,
              });
            }
          })
          .catch((error) => {
            // token expired, log out user
            if (error.response && error.response.status === 403) {
              userLogoutRequestSynch(token)(dispatch)
                .then(() => this.setState({
                  snackbarOpen: true,
                  snackbarVariant: 'error',
                  snackbarMessage: 'Your session has expired. Login again to purchase routines',
                  loggedIn: false,
                }));
            } else {
              console.log('failed to get user info');
              console.log(error.response);
              this.setState({
                snackbarOpen: true,
                snackbarVariant: 'error',
                snackbarMessage: 'Failed to load your user info',
              });
            }
          });
      }
    }
  }

  addToCart(e, product) {
    const { token } = this.props;
    this.setState({ addButtonLoading: product.id });
    addProductToCart(token, product.url)
      .then((response) => {
        this.setState({
          addButtonLoading: false,
          snackbarOpen: true,
          snackbarVariant: 'success',
          snackbarMessage: 'Product added to cart',
        });
      })
      .catch((error) => {
        // console.log(error);
        this.setState({
          snackbarOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: 'Failed to add product',
        });
      });
  }

  handleClose(e, reason) {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ snackbarOpen: false });
  }

  render() {
    const { classes } = this.props;
    const { category } = this.props.match.params;
    const {
      loggedIn,
      hasMembership,
      loading,
      products,
      snackbarOpen,
      snackbarVariant,
      snackbarMessage,
      addButtonLoading,
      userInfo,
      filter,
      filteredProducts,
      notFound,
    } = this.state;

    const {
      token,
      id,
    } = this.props;

    if (notFound) {
      return (
        <Redirect to="/404" />
      );
    }

    let allowAdd = loggedIn;
    let tooltipText = '';
    let subHeaderText = '';
    // routine special handling
    if (category === 'routines') {
      allowAdd = loggedIn && hasMembership;
      if (!hasMembership) {
        tooltipText = 'Must have a Nia Membership';
        subHeaderText = 'You must have an active Nia Membership to purchase Routines';
      }
    }
    if (!loggedIn) {
      tooltipText = 'Must be Logged In';
      subHeaderText = `You must be logged in to purchase ${category}.`;
    }

    // trainer store but not trainer?
    if (!loading && token && id && (category === 'trainers')) {
      if (!userInfo.is_trainer) {
        return (
          <div className={classes.loggedOutContainer}>
            <img alt="error icon" className={classes.errorIcon} src={errorIcon} />
            <Typography className={classes.loggedOutMessage} variant="subtitle1">
              You&apos;re not supposed to be here!
            </Typography>
            <Button href="/login" className={classes.loggedOutOptions} variant="outlined" color="primary">Login</Button>
            <Button href="/register" className={classes.loggedOutOptions} variant="outlined" color="primary">Register</Button>
          </div>
        );
      }
    }

    return (
      <React.Fragment>

        {category === 'routines' && (
          <Helmet>
            <title>Nia Routines Shop | Download Dance Workouts and More</title>
            <meta name="description" content="Visit the Nia routines shop to download your favorite dance workouts, mind body fitness classes, and more. Click here to start listening today." />
            <meta name="keywords" content="mind, body, fitness, workout, online" />
          </Helmet>
        )}
        {category === 'videos' && (
          <Helmet>
            <title>Nia Videos Shop | Dance Workout Downloads and DVDs</title>
            <meta name="description" content="Visit the Nia videos shop for your favorite dance workouts, mind body fitness classes, and more. Click here to download or order a DVD today." />
            <meta name="keywords" content="mind, body, fitness, workout, online" />
          </Helmet>
        )}
        {category === 'music' && (
          <Helmet>
            <title>Nia Music Shop | Music for Mind Body Fitness </title>
            <meta name="description" content="Visit the Nia music shop to download your favorite tracks and albums from our mind body fitness classes. Click here to start listening today." />
            <meta name="keywords" content="mind, body, fitness" />
          </Helmet>
        )}

        <div className={classes.headerSection}>
          <Typography className={classes.header} color="textSecondary" variant="h1">{category.charAt(0).toUpperCase() + category.slice(1)}</Typography>
          {!allowAdd && (
            <Typography className={classes.subHeader} color="error" variant="p">{subHeaderText}</Typography>
          )}
        </div>

        {/*{category === 'routines' && (
          <div className={classes.saleBanner}>
            <img src={saleBanner} className={classes.saleBannerImg} alt="sale banner use code save25"/>
          </div>
        )}*/}

        <div className={classes.actionArea}>
          <TextField
            variant="outlined"
            label="Search"
            value={filter}
            onChange={
              (e) => {
                this.setState({
                  filter: e.target.value,
                  filteredProducts: products.filter(product => product.title.toLowerCase().includes(e.target.value ? e.target.value.toLowerCase() : '')),
                });
              }
            }
          />
          <Button href="/shop/cart" className={classes.action}>View Cart</Button>
          <Button href="/shop/checkout" className={classes.action} color="secondary">Checkout Now</Button>
        </div>
        <div className={classes.list}>
          {loading
            ? <CircularProgress color="secondary" className={classes.loadingSpinner} />
            : filteredProducts.map(product => (
            // PRODUCT CARD
              <ProductCard
                key={product.id}
                product={product}
                addButtonLoading={addButtonLoading}
                allowAdd={allowAdd}
                addToCart={this.addToCart}
                tooltipText={tooltipText}
              />
            ))
          }
        </div>

        {/* SNACKBAR */}
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          open={snackbarOpen}
          autoHideDuration={5000}
          onClose={this.handleClose}
        >
          <MySnackbarContentWrapper
            onClose={this.handleClose}
            variant={snackbarVariant}
            message={snackbarMessage}
          />
        </Snackbar>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  let id = null;
  let token = null;
  if (state.loginReducer.user) {
    id = state.loginReducer.user.id;
    token = state.loginReducer.token;
  }
  return {
    id,
    token,
  };
}


ProductList.propTypes = {
  id: PropTypes.number,
  token: PropTypes.string,
  classes: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withStyles(styles)(connect(mapStateToProps)(ProductList));
